import React from 'react';
import { PatentPopup } from '../../../assets/images';
import styles from './patentsFoot.module.scss';

interface PatentsFootProps {
  onClose: () => void;
}

const patentsFoot: React.FC<PatentsFootProps> = ({ onClose }) => {
  return (
    <div className={styles.popupOverlay} onClick={onClose}>
    <div className={styles.popupContent} onClick={(e) => e.stopPropagation()}>
      {/* <button className={styles.closeButton} onClick={onClose}>✖</button> */}
      <img className={styles.patent} src={PatentPopup} alt="Patent Popup" />
    </div>
  </div>
  );
};

export default patentsFoot;
